import { render, staticRenderFns } from "./setExpress.vue?vue&type=template&id=08b00c9e&scoped=true&"
import script from "./setExpress.vue?vue&type=script&lang=js&"
export * from "./setExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b00c9e",
  null
  
)

export default component.exports